import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

export default function HeaderV2() {
  const { userData } = useContext(AuthContext);

  return (
    <header className="header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-5 col-6"></div>
          <div className="col-lg-7 col-md-7 col-6">
            <div className="header-right">
              <div className="profile-box ml-15">
                <button
                  className="dropdown-toggle bg-transparent border-0"
                  type="button"
                  id="profile"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="profile-info">
                    <div className="info d-flex align-items-center">
                      <div className="image me-2">
                        {userData?.photoURL ? (
                          <img
                            src={userData.photoURL}
                            alt={userData.name || "Usuário"}
                            style={{ width: 40, height: 40, borderRadius: "50%" }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              backgroundColor: "#ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#666",
                              fontSize: 14,
                            }}
                          >
                            ?
                          </div>
                        )}
                      </div>
                      <div>
                        <h6 className="fw-500">{userData?.name || "Usuário"}</h6>
                        <p>Admin</p>
                      </div>
                    </div>
                  </div>
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="profile"
                >
                  <li>
                    <div className="author-info flex items-center !p-1">
                      <div className="image me-2">
                        {userData?.photoURL ? (
                          <img
                            src={userData.photoURL}
                            alt={userData.name || "Usuário"}
                            style={{
                              width: 50,
                              height: 50,
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 50,
                              height: 50,
                              borderRadius: "50%",
                              backgroundColor: "#ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#666",
                              fontSize: 16,
                            }}
                          >
                            ?
                          </div>
                        )}
                      </div>
                      <div className="content">
                        <h4 className="text-sm">{userData?.name || "Usuário"}</h4>
                        <a
                          className="text-black/40 dark:text-white/40 hover:text-black dark:hover:text-white text-xs"
                          href={`mailto:${userData?.email || ""}`}
                        >
                          {userData?.email || "Email não disponível"}
                        </a>
                      </div>
                    </div>
                  </li>
                  <li className="divider"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
